<div *ngIf="reportType === 'VeryBriefly-Officer'" class="report-wrapper">
    
    <div class="report-container" id="print-section">
        
        <!-- Report Header Section -->
        <div class="report-header">
            <div class="header-row">
                <div class="company-name">Vivek Saptahik</div>
                <div class="report-title">Book Payment Receipt Ledger</div>
                <div class="report-type">Very Briefly</div>
                <div class="report-date">{{currentDate | date: 'dd-MM-yyyy'}}</div>
            </div>
            <div class="sub-header-row">
                <div class="report-category">Office Representative Wise</div>
                <div class="date-range">From {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</div>
                <div class="page-info">Page No: 1</div>
            </div>
        </div>

        <!-- Main Report Table -->
        <div class="table-container">
            <table class="report-table">
                <thead>
                    <tr class="table-header">
                        <th class="col-rep-name">Representative Name</th>
                        <th class="col-office-rep">Office Representative Name</th>
                        <th class="col-amount">Received Amount</th>
                        <th class="col-total">Total</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let data of bookFormBeans; let i = index">
                        
                        <!-- Office Representative Header -->
                        <tr class="office-rep-header">
                            <td colspan="4" class="office-rep-title">
                                <span class="office-rep-label">Office Representative:</span>
                                <span class="office-rep-name">{{data.office_rep_name}}</span>
                            </td>
                        </tr>

                        <!-- Representative Data Rows -->
                        <tr *ngFor="let data1 of data.rep_data; let j = index" class="rep-data-row">
                            <td class="rep-name">{{data1.rep_name}}</td>
                            <td class="office-rep">{{data.office_rep_name}}</td>
                            <td class="amount">{{data1.select_entry_amt | number:'1.2-2'}}</td>
                            <td class="empty-cell">-</td>
                        </tr>
                        
                        <!-- Subtotal Row -->
                        <tr class="subtotal-row">
                            <td class="subtotal-label">{{data.office_rep_name}} - Subtotal</td>
                            <td class="subtotal-text">Total</td>
                            <td class="empty-cell">-</td>
                            <td class="subtotal-amount">{{data.total | number:'1.2-2'}}</td>
                        </tr>

                    </ng-container>
                </tbody>

                <!-- Grand Total Footer -->
                <tfoot>
                    <tr class="grand-total-row">
                        <td colspan="3" class="grand-total-label">GRAND TOTAL:</td>
                        <td class="grand-total-amount">{{bookVBTotal | number:'1.2-2'}}</td>
                    </tr>
                </tfoot> 
            </table>
        </div>
       
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons noPrint">
        <button class="btn btn-export noPrint" 
                (click)="exportExcel('BookReceipts_VeryBriefly_Report')" 
                mat-raised-button 
                color="primary">
            <mat-icon>download</mat-icon>
            Export to Excel
        </button>

        <!-- <button class="btn btn-print noPrint"
                (click)="printPage4()"
                mat-raised-button 
                color="primary">
            <mat-icon>print</mat-icon>
            Print Report
        </button> -->
         <button class="btn btn-print noPrint" id="print-button" mat-raised-button color="primary" printSectionId="print-section"
          [useExistingCss]="true" ngxPrint style="display: none;">Print</button>
  
        <button class="btn btn-print noPrint" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>
    
        <button class="btn btn-close noPrint" 
                mat-button 
                mat-dialog-close>
            <mat-icon>close</mat-icon>
            Close
        </button>
    </div>

</div>